import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fbPageView } from "@/lib/pixel";

/**
 * Fires a Meta Pixel PageView on every SPA route change.
 * The base <script> in public/index.html already fires the initial PageView.
 */
export default function PageViewTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    fbPageView();
  }, [pathname, search]);
  return null;
}
